import { Avatar as MuiAvatar, Theme } from "@material-ui/core";
import styled from "styled-components";

export const Avatar = styled(MuiAvatar)<{ theme: Theme }>`
  border: 2px solid ${(props) => props.theme.palette.grey[800]};
  height: 2.5rem;
  width: 2.5rem;
`;
